import { DropdownSelect } from "app/core/components/input"
import { TTemplateSortBy } from "../TemplateGallery"
import React from "react"

const TemplateSortSelect = ({
  templateSortBy,
  setTemplateSortBy,
}: {
  templateSortBy: TTemplateSortBy
  setTemplateSortBy: (sortBy: TTemplateSortBy) => void
}) => {
  const options = [
    { label: "Newest", value: "createdAtDesc", icon: clockUp },
    { label: "Oldest", value: "createdAtAsc", icon: clockDown },
    { label: "Recently Updated", value: "updatedAtDesc", icon: bellPlus },
  ]

  return (
    <DropdownSelect
      className="w-[200px] text-sm font-normal"
      overrideWrapperClassname="bg-grayscale-dark rounded-lg !px-1 max-w-[210px] w-full border border-1 border-white border-opacity-7"
      options={options}
      borderless={true}
      isSearchable={false}
      value={options.find((option) => option.value === templateSortBy)}
      onChange={(option) => setTemplateSortBy(option!.value as TTemplateSortBy)}
      formatOptionLabel={(option) => {
        const IconSvg = options.find((o) => o.value === option.value)?.icon
        return (
          <div className="flex flex-row gap-3 items-center cursor-auto">
            {IconSvg &&
              React.cloneElement(IconSvg, {
                className: "text-brand-primary h-4 w-4",
              })}
            <p>{option.label}</p>
          </div>
        )
      }}
      placeholder="Sort by..."
    />
  )
}

const clockUp = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M13.228 21.925A10 10 0 1 1 21.994 12.338" />
    <path d="M12 6v6l1.562.781" />
    <path d="m14 18 4-4 4 4" />
    <path d="M18 22v-8" />
  </svg>
)

const clockDown = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12.338 21.994A10 10 0 1 1 21.925 13.227" />
    <path d="M12 6v6l2 1" />
    <path d="m14 18 4 4 4-4" />
    <path d="M18 14v8" />
  </svg>
)

const bellPlus = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M19.3 14.8C20.1 16.4 21 17 21 17H3s3-2 3-9c0-3.3 2.7-6 6-6 1 0 1.9.2 2.8.7" />
    <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
    <path d="M15 8h6" />
    <path d="M18 5v6" />
  </svg>
)

export default TemplateSortSelect
